export const frontpageGuidelinesLW = `
  <p><em>Frontpage comment guidelines:</em></p>
  <ul>
    <li>Aim to explain, not persuade</li>
    <li>Try to offer concrete models and predictions</li>
    <li>If you disagree, try getting curious about what your partner is thinking</li>
    <li>Don't be afraid to say 'oops' and change your mind</li>
  </ul>`

export const defaultGuidelinesLW = `
<p><em>Default comment guidelines:</em></p>
<ul>
  <li>Aim to explain, not persuade</li>
  <li>Try to offer concrete models and predictions</li>
  <li>If you disagree, try getting curious about what your partner is thinking</li>
  <li>Don't be afraid to say 'oops' and change your mind</li>
</ul>`
